<template>
  <div>
    <LeftNavigation
      :leftNavDrawer="leftNavDrawer"
      :leftNavDrawerItems="leftNavDrawerItems"
    />
    <Toolbar v-on:toolbarSideIconClick="leftNavDrawer = !leftNavDrawer" />
  </div>
</template>

<script>
import LeftNavigation from "./LeftNavigation";
import Toolbar from "./Toolbar";
export default {
  name: "Header",
  components: { LeftNavigation, Toolbar },
  data: () => ({
    leftNavDrawer: true,
    // Left Nav Items
    leftNavDrawerItems: [
      {
        key: "basic-nav",
        items: [
          { title: "Home", icon: "home", path: "/home" },
          { title: "Data Export", icon: "cloud_download", path: "/export" },
          { title: "Device Graph", icon: "insert_chart", path: "/graph" },
        ],
      },
      {
        key: "devices",
        items: [
          { title: "Organisations", icon: "phonelink", path: "/organisations" },
          {
            title: "Project Groups",
            icon: "phonelink",
            path: "/projectgroups",
          },
          { title: "Device Types", icon: "phonelink", path: "/devicetypes" },
          { title: "Devices", icon: "phonelink", path: "/devices" },
        ],
      },
      {
        key: "manifest",
        items: [
          { title: "Group Info", icon: "phonelink", path: "/groupinfos" },
          { title: "Asset Info", icon: "phonelink", path: "/assetinfos" },
          { title: "Physical Info", icon: "phonelink", path: "/physicalinfos" },
        ],
      },
      {
        key: "admin",
        admin: true,
        items: [
          {
            title: "Sigfox Dashboard",
            icon: "monitor",
            path: "/sigfox_dashboard",
          },
        ],
      },
      {
        key: "account",
        items: [
          { title: "Account", icon: "perm_identity", path: "/account" },
          { title: "Logout", icon: "exit_to_app", path: "/logout" },
        ],
      },
    ],
  }),
};
</script>
